<template>
  <div id="app">
    <div v-if="showBrowserTip" class="browser-tip-mask">
      <img class="browser-tip-img" src="@/assets/img/uplode.png" alt="请在浏览器中打开" />
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
// 微信内访问时需引导「浏览器打开」的域名
const WECHAT_EXTERNAL_OPEN_HOSTS = [
  "fa.xybfb.com","fa.aipy365.com"
];

export default {
  name: "App",
  data() {
    return {
      showBrowserTip: false,
    };
  },
  created() {
    const ua = navigator.userAgent.toLowerCase();
    const isWechat = ua.includes("micromessenger");
    const isTargetHost = WECHAT_EXTERNAL_OPEN_HOSTS.includes(location.hostname);
    this.showBrowserTip = isWechat && isTargetHost;
  },
};
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // height: 100%;
  color: #444;
  background: #f9f9f9;
}
.browser-tip-mask {
  position: fixed;
  inset: 0;
  z-index: 99999;
  width: 100%;
  height: 100%;
  padding: 20px;
  background: rgba(0, 0, 0, 0.05);
  overflow: hidden;
}
.browser-tip-img {
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
  object-position: top center;
}
/* 强制修复QQ浏览器PC端拉伸的终极手段 */
@media screen and (min-width: 769px) {
  body {
    width: 750px !important;
    margin: 0 auto !important;
    left: 0 !important;
    right: 0 !important;
    position: relative !important;
  }
  #app {
    width: 100% !important;
    max-width: 750px !important;
  }
}
</style>
